import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TowerWriteActionButtons from './TowerWriteActionButtons';
import { initialize, writeTower, updateTower } from '../../modules/tower/towerWriteSlice';

const TowerWriteActionButtonsContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { title, body, tags, tower, towerError, originalTowerId } = useSelector(({ towerWrite }) => ({
        title: towerWrite.title,
        body: towerWrite.body,
        tags: towerWrite.tags,
        tower: towerWrite.tower,
        towerError: towerWrite.towerError,
        originalTowerId: towerWrite.originalTowerId,
    }));

    const project = useSelector(state => state.project.project);

    // 포스트 등록
    const onPublish = () => {
        if (originalTowerId) {
            dispatch(updateTower({ title, body, tags, id: originalTowerId }));
            return;
        }
        /* 이름이 넣지 않았을 때 */
        if (!title) {
            alert('타워 이름을 입력하세요');
            return;
        }
        /* 아무 값도 넣지 않고 저장하지 못하게 (필요시 구현) */
        
        // 데이터베이스에 쓰기
        dispatch(
            writeTower({
                title,
                body,
                tags,
                project
            }),
        );
    };

    // 취소
    const onCancel = () => {
        //dispatch(initialize());   // 이게 아니네...
        navigate(-1);
    };

    // 성공 혹은 실패 시 할 작업
    useEffect(() => {
        if (tower) {
            // const { _id } = tower;
            // navigate(-1);

            dispatch(initialize());
            
            /* 성공했을때 어디로 갈지 구현 예정. '24.4/25 */            
            navigate(`/projects/${project?._id}/towers`);
        }
        if (towerError) {
            console.error(towerError);
        }
    }, [dispatch, navigate, project?._id, tower, towerError]);

    return <TowerWriteActionButtons onCancel={onCancel} onPublish={onPublish} isEdit={!!originalTowerId} />;
};

export default TowerWriteActionButtonsContainer;
